/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_LoadingInputs */

const en_cases_loading = /** @type {(inputs: Cases_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading cases...`)
};

const pt_br2_cases_loading = /** @type {(inputs: Cases_LoadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando casos...`)
};

/**
* | output |
* | --- |
* | "Loading cases..." |
*
* @param {Cases_LoadingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_loading = /** @type {((inputs?: Cases_LoadingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_LoadingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_loading(inputs)
	return pt_br2_cases_loading(inputs)
});